"use client";

import React, { useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Mouse, ArrowRight, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PremierCleaningExcellence() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const quoteUrl = "/ContactUsPage";
  const phoneUrl = "tel:0212345678";
  return <section id="premier-cleaning-excellence" className="relative h-[90vh] w-full overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        {}
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568801/img/commercial_cleaning_hero_video_poster.png" alt="Commercial cleaning service in action" className="h-full w-full object-cover" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/80 mix-blend-multiply" />
        <div className="absolute inset-0 bg-black/40" /> {}
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        
        {}
        <div ref={textRef} className={`max-w-5xl transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <span className="mb-6 inline-block text-sm font-bold tracking-[0.2em] text-primary uppercase sm:text-base">
            Premier Commercial Cleaning
          </span>
          
          <h1 className="text-4xl font-bold leading-tight text-white !font-sans sm:text-5xl md:text-6xl lg:text-[72px]">Commercial Cleaning for Executive Spaces</h1>
        </div>

        {}
        <div ref={ctaRef} className={`mt-10 flex flex-col items-center gap-6 sm:flex-row sm:gap-8 transition-all duration-1000 delay-300 ease-out ${isCtaVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Button asChild size="lg" className="h-14 min-w-[200px] rounded-full bg-primary px-8 text-base font-semibold text-primary-foreground shadow-[0_0_20px_rgba(234,179,8,0.3)] hover:bg-primary/90 hover:shadow-[0_0_30px_rgba(234,179,8,0.5)]">
            <Link to={quoteUrl}>
              Request a Quote
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="h-14 min-w-[200px] rounded-full border-2 border-primary bg-transparent px-8 text-base font-semibold text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary">
            <Link to={phoneUrl} className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 h-14 min-w-[200px] rounded-full border-2 border-primary bg-transparent px-8 text-base font-semibold text-primary inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 h-14 min-w-[200px] rounded-full border-2 border-primary bg-transparent px-8 text-base font-semibold text-primary !shadow-none disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-primary hover:text-primary-foreground hover:border-primary disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-primary hover:text-primary-foreground hover:border-primary">Call Now</Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 animate-bounce">
        <div className="flex flex-col items-center gap-2 opacity-70 transition-opacity ![margin:0px_-40px_0px_-40px] hover:opacity-100">
          <span className="text-xs font-medium tracking-widest text-white/80 uppercase">Scroll Down</span>
          <Mouse className="h-6 w-6 text-primary" />
        </div>
      </div>
    </section>;
}